import { NavLink } from "react-router-dom"
import UserImage from "./UserImage"
import { Children } from "react"

export default function AvatarMini({
    displayName,
    guid,
    abbreviate = false,
    destination = "/dashboard/employees/see-employment",
    style = null,
    children = null
}) {

    function abbreviateName() {
        // Rimuove spazi extra e divide nome e cognome
        const parti = displayName.trim().split(/\s+/);

        if (parti.length < 2) {
            // Se c'è solo una parola, restituisce così com'è
            return displayName;
        }

        // Prende la prima lettera del nome e tutto il resto come cognome
        const firstname = parti[0];
        const surname = parti.slice(1).join(' ');

        return `${firstname.charAt(0).toUpperCase()}. ${surname}`;
    }

    // https://picsum.photos/seed/${user.guid}/60/60
    //https://ui-avatars.com/api/?name=John+Doe

    return (
        <NavLink to={{ pathname: destination }} state={{ userGUID: guid }} className="btn btn-dark"  style={style}>
            {/* <img className="rounded-circle p-1 me-2" width="48px" src={`https://ui-avatars.com/api/?name=${displayName.replace(" ", "+")}&background=random`}/>{displayName} */}
            <UserImage guid={guid} size={48} /> <span className="ps-2">{abbreviate ? abbreviateName() :displayName}</span> {children}
        </NavLink>
    )
}